var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, centerScreen: "", maxWidth: "80%" },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("span", { staticClass: "text-heading-small ml-4 mt-2" }, [
                _vm._v(_vm._s(_vm.fileName))
              ])
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function(ref) {
            var closeModal = ref.close
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: closeModal } },
                [_vm._v(" Fechar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: {
                    primary: "",
                    disabled: !_vm.url,
                    loading: _vm.downloading
                  },
                  on: { click: _vm.onDownload }
                },
                [_vm._v(" Baixar ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        {
          staticClass:
            "task-comment-attachment-viewer pa-4 d-flex justify-center"
        },
        [
          _vm.url
            ? _c("img", {
                staticClass: "viewer-image",
                attrs: { src: _vm.url, alt: _vm.fileName },
                on: { error: _vm.onImageError }
              })
            : _c("div", { staticClass: "az-text-small text-color-400 pa-4" }, [
                _vm._v(" Não foi possível carregar a imagem. ")
              ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }